<template>
  <div>

    <hf-header
      width='100%'
      :showLinks="true"
    />
    <hf-banner />

    <div id="services" class="services">
      <h1 id="services-h1">{{ $t('pages.index.services.title') }}</h1>
      <div class="services-container">
        <div class="services-grid">
          <hf-service v-for="(item, index) in serviceIcons" :key="index"
            :title="$t('pages.index.services.service[' + index + '].title')"
            :imgUrl="serviceIcons[index]"
            :desc="$t('pages.index.services.service[' + index + '].desc')"
          />
        </div>
      </div>
    </div>

    <div id="about" class="about">
      <h1>{{ $t('pages.index.about.title') }}</h1>
      <p>{{ $t('pages.index.about.subtitle') }}</p>
      <div class="about-container">
        <div class="about-grid">
          <hf-person v-for="(person, index) in people" :key="index"
            :id=person.name
            :name="$t('pages.index.about.' + person.name + '.name')"
            :title="$t('pages.index.about.' + person.name + '.title')"
            :imgUrl  = person.imgUrl
            :desc="$t('pages.index.about.' + person.name + '.desc')"
            :linkedin="$t('pages.index.about.' + person.name + '.linkedin')"
          />
        </div>
      </div>
      <div class="join">
        <p>{{ $t('pages.index.about.para1') }}</p>
        <p>{{ $t('pages.index.about.para2') }}</p>
        <div class="butt
        on">{{ $t('pages.index.about.email') }}</div>
      </div>
    </div>

    <div id="projects" class="projects">
      <div class="separator"></div>
      <h1>{{ $t('pages.index.projects.title') }}</h1>
      <hf-project v-for="(project, index) in projects" :key="index"
        :title="$t('pages.index.projects.' + project.name + '.title')"
        :imgUrl="projectImages[project.name]"
        :desc="$t('pages.index.projects.' + project.name + '.desc')"
        :caseStudy=project.caseStudy
      />
    </div>

    <div id="testimonials" class="testimonials section">
      <h1>{{ $t('pages.index.testimonials.subtitle') }}</h1>
      <div class="slide-wrapper">
        <vueper-slides
          :visible-slides="3"
          :dragging-distance="70"
          slide-multiple
          autoplay
          fixed-height=true
          :arrows="true"
          class="no-shadow"
          :breakpoints="breakpoints"
          speed=10000
          transition-speed='1000'
        >
        <template v-slot:arrow-left>
          <div>
            <span class="arrow left"></span>
          </div>
        </template>
        <template v-slot:arrow-right>
          <div>
            <span class="arrow right"></span>
          </div>
        </template>
          <vueper-slide v-for="(slide, i) in testimonials"
            :key="i"
            :title="$t('pages.index.testimonials.' + slide.name + '.title')">
            <template v-slot:content>
              <hf-testimonial
                :title="$t('pages.index.testimonials.' + slide.name + '.title')"
                :name="$t('pages.index.testimonials.' + slide.name + '.name')"
                :imgUrl=slide.imgUrl
                :linkedin="$t('pages.index.testimonials.' + slide.name + '.linkedin')"
                :quote="$t('pages.index.testimonials.' + slide.name + '.quote')"
              ></hf-testimonial>
            </template>
          </vueper-slide>
        </vueper-slides>
      </div>
    </div>

    <div id="contact" class="contact">
      <h1>{{ $t('pages.index.contact.title') }}</h1>
      <p>{{ $t('pages.index.contact.para1') }}</p>
      <hf-contact />
    </div>

  </div>
</template>

<script>
  import { VueperSlides, VueperSlide } from 'vueperslides'
  import 'vueperslides/dist/vueperslides.css'

  import pm_icon from "../assets/icons/product-management.svg";
  import sa_icon from "../assets/icons/solutions-architecture.svg";
  import qa_icon from "../assets/icons/testing.svg";
  import do_icon from "../assets/icons/devops.svg";
  import pr_icon from "../assets/icons/project-management.svg";
  import dy_icon from "../assets/icons/delivery.svg";
  // Internal Profiles:
  import stace_profile from "../assets/profiles/stace.jpeg";
  import adam_profile from "../assets/profiles/adam.jpeg";
  import david_profile from "../assets/profiles/david.jpeg";
  import katie_profile from "../assets/profiles/katie.jpeg";
  import tarun_profile from "../assets/profiles/tarun.jpeg";
  import mikey_profile from "../assets/profiles/mikey.jpeg";
  import jes_profile from "../assets/profiles/jes.jpeg"
  // External Profiles:
  import spencer_profile from "../assets/profiles/spencer.jpeg";
  import mike_profile from "../assets/profiles/mike.jpeg";
  import amir_profile from "../assets/profiles/amir.jpeg";
  import lara_profile from "../assets/profiles/lara.jpeg";
  import seb_profile from "../assets/profiles/seb.jpeg";
  import chris_profile from "../assets/profiles/chris.jpeg";
  // Project Icons:
  import img_pshare from "../assets/projects/case-study-pshare.png"
  import img_sharedis from "../assets/projects/case-study-sharedis.png"
  import img_cardano from "../assets/projects/case-study-ledger.png"
  import img_moj from "../assets/projects/case-study-MOJ.png"
  import img_mod from "../assets/projects/case-study-MOD.png"
  import img_mint from "../assets/projects/case-study-royal-mint.png"
  import img_pq from "../assets/projects/case-study-post-quantum.png"

  const projectImages = {
    'pshare': img_pshare,
    'sharedis': img_sharedis,
    'cardano' : img_cardano,
    'moj' : img_moj,
    'mod' : img_mod,
    'mint' : img_mint,
    'pq' : img_pq
  }

  const serviceIcons = [ pm_icon, dy_icon, pr_icon, sa_icon, do_icon, qa_icon ];
  const testimonials = [
    {
      name: 'amir',
      imgUrl: amir_profile
    },
    {
      name: 'chris',
      imgUrl: chris_profile
    },
    {
      name: 'lara',
      imgUrl: lara_profile
    },
    {
      name: 'mike',
      imgUrl: mike_profile
    },
    {
      name: 'seb',
      imgUrl: seb_profile
    },
    {
      name: 'spencer',
      imgUrl: spencer_profile
    }
  ];
  const people = [
    {
      "name": "adam",
      "imgUrl": adam_profile
    },
    {
      "name": "stace",
      "imgUrl": stace_profile
    },
    {
      "name": "dave",
      "imgUrl": david_profile
    },
    {
      "name": "tarun",
      "imgUrl": tarun_profile
    },
    {
      "name": "katie",
      "imgUrl": katie_profile
    },
    {
      "name": "mikey",
      "imgUrl": mikey_profile
    },
    {
      "name": "jessica",
      "imgUrl": jes_profile
    },
  ]
  const projects = [
    {
      name: 'pshare',
      caseStudy: false
    },
    {
      name: 'sharedis',
      caseStudy: false
    },
    {
      name: 'cardano',
      caseStudy: false
    },
    {
      name: 'moj',
      caseStudy: false
    },
    {
      name: 'mod',
      caseStudy: false
    },
    {
      name: 'mint',
      caseStudy: false
    },
    {
      name: 'pq',
      caseStudy: false
    }
  ];

  export default {
    components: { VueperSlides, VueperSlide },
    data: function() {
      return {
        breakpoints: {
          1200: {
            arrows: true,
            visibleSlides: 2,
            disableArrowsOnEdges: true,
            bullets: false
          },
          800: {
            arrows: true,
            disableArrowsOnEdges: true,
            visibleSlides: 1,
            bullets: false
          },
          400: {
            arrows: false,
            visibleSlides: 1
          }
        },
        serviceIcons,
        people,
        projects,
        projectImages,
        testimonials
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  h1 {
    margin-top: 75px;
    margin-bottom: 0px;
    margin-left: 32px;
    text-align: left;
    font-family: $title-font;
    font-size: 31px;
    font-weight: 600;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin: 75px 0 0 50px;
    }

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      font-size: 36px;
      margin: 75px 0 0 0;
    }

    @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
      h1 {
        margin-bottom: 100px;
      }
    }

    @media screen and (min-width: $screen-L-min) {
      margin-bottom: 50px;
    }
  }

  p {
    margin: 24px $margin-left;
    line-height: 1.6em;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin: 24px 15%;
    }
  }

  .services {

    overflow: hidden;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin: 0 50px;

      #services-h1 {
        margin-left: 0;
      }
    }

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      margin: 0 15%;
    }

    @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
      margin: 0 10%;
    }

    @media screen and (min-width: $screen-XL-min) {
      margin: 0 10%;
    }

    .services-container {
      display: flex;
      justify-content: center;
    }

    .services-grid {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  .about {

    overflow: hidden;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin: 0 50px;

      #services-h1 {
        margin-left: 0;
      }
    }

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      margin: 0 15%;
    }

    @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
      margin: 0 10%;
    }

    @media screen and (min-width: $screen-XL-min) {
      margin: 0 10%;
    }

    p {
      @media screen and (min-width: $screen-L-min) {
        margin: 2% 5%;
        width: 60%;
      }
    }

    .about-container {
      display: flex;
      justify-content: center;
    }

    .about-grid {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }


    .join {
      clear: both;
      text-align: center;
      font-weight: 600;
      padding-bottom: 10px;

      p {
        margin: 32px;

        @media screen and (min-width: $screen-L-min) {
          width: 100%;
          padding: 0;
          margin: 32px 0;
        }
      }

      .button {
        width: 258px;
        height: 53px;
        border-radius: 26.5px;
        box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.2);
        background-color: #36c1f1;
        line-height: 53px;
        text-align: center;
        margin: auto;
        color: white;
        cursor: pointer;
        font-size: 14px;
      }
    }
  }

  .projects {
    margin-top: 65px;
    background: $bg-grey;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin-top: 150px;
    }

    h1 {
      margin-top: -50px;

      @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
        margin-top: -50px;
      }

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin-left: 15%;
        margin-top: -50px;
      }

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        margin-left: 20%;
        margin-top: -50px;
      }

      @media screen and (min-width: $screen-XL-min) {
        margin-left: 20%;
        margin-top: -50px;
      }
    }

    .separator {
      background: white;
      min-width: 320px;
      color: white;
      background-image: url('../assets/bkgs/section-break-shape.svg');
      background-position: top 2px left -100px;
      height: 200px;
      background-repeat: no-repeat;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        background-position: top 2px left;
        background-size: cover;
      }

      @media screen and (min-width: $screen-L-min) {
        height: 35vh;
        background-size: cover;
        background-position: top 2px left;
      }
    }
  }

  .testimonials {

    background: $bg-grey;
    overflow: hidden;

    @media screen and (min-width: $screen-L-min) {
      padding: 80px 0;
    }

    h1 {
      margin-top: 100px;
      margin-bottom: 20px;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin-left: 15%;
      }

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        margin-left: 20%;
      }

      @media screen and (min-width: $screen-XL-min) {
        margin-left: 25%;
      }
    }

    .slide-wrapper {

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        width: 700px;
        margin: auto;
      }

      @media screen and (min-width: $screen-L-min) and (max-width: $screen-L-max) {
        width: 72%;
        margin: auto;
      }

      @media screen and (min-width: $screen-XL-min) {
        width: 50%;
        margin: auto;
      }
    }


    .vueperslides--fixed-height { height: 400px; background: $bg-grey; }

    .vueperslide--active {
      background: $bg-grey;
    }

    .arrow_wrapper {
      border: 1px solid $slide-blue;
      border-radius: 20px;
      background-color: $white;
    }

    .arrow {
      display: inline-block;
      border: 1px solid $slide-blue;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: white;
      opacity: 1;
    }

    .arrow:after {
      content: '';
      display: inline-block;
      margin-top: 9px;
      width: 10px;
      height: 10px;
      border-top: 3px solid $slide-blue;
    }

    /* https://codepen.io/gin85cc/pen/jrOgRq*/

    .left {
      margin-right: 1.5em;
    }

    .left:after {
      margin-left: 5px;

      border-right: 3px solid $slide-blue;
      -moz-transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
      transform: rotate(-135deg);
    }

    .right {
      margin-left: 1.5em;
    }

    .right:after {
      margin-left: -5px;
      border-right: 3px solid $slide-blue;
      -moz-transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  .contact {

    h1 {
      margin-top: 100px;
      margin-bottom: 20px;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin-left: 15%;
      }

      @media screen and (min-width: $screen-L-min) {
        display: none;
      }
    }

    p {
      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        margin: 20px 15%;
      }

      @media screen and (min-width: $screen-L-min) {
        display: none;
      }
    }

    background: $bg-grey;
    overflow: hidden;
  }

</style>
